import { not } from 'ramda';
import React, { FC, MouseEventHandler } from 'react';
import styled from 'styled-components';

import Button from '@ui/atoms/Button';
import NavigationSection from '@ui/atoms/NavigationSection';

import spaced from '@ui/styled/Spaced';

import { commonLabels } from '@utils/button';

import { SpacingTypes } from '@folx-types/theme';

import SubmitButton from '../SubmitButton';

export interface IBackAndNextNavProps {
	className?: string;
	marginBottom?: SpacingTypes | false;
	marginTop?: SpacingTypes | false;
	submitLabel?: string;
	submitting?: boolean;
	hideBack?: boolean;
	backOnClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
	nextOnClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
}

const SpacedNavigationSection = spaced(NavigationSection);

const BackAndNextNav: FC<IBackAndNextNavProps> = ({
	className,
	marginTop,
	marginBottom,
	submitLabel,
	submitting,
	hideBack,
	backOnClick,
	nextOnClick,
}) => {
	return (
		<SpacedNavigationSection marginTop={marginTop} marginBottom={marginBottom}>
			{not(hideBack) && (
				<Button className={className} label={commonLabels.back} onClick={backOnClick} />
			)}
			{nextOnClick ? (
				<Button
					className={className}
					variant="secondary"
					label={commonLabels.next}
					onClick={nextOnClick}
				/>
			) : (
				<SubmitButton
					className={className}
					variant="secondary"
					label={submitLabel}
					submitting={submitting}
				/>
			)}
		</SpacedNavigationSection>
	);
};

export default styled(BackAndNextNav)``;
